<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="overlay"></div>
      <div :class="{modalContent: true, modalBig: true}">
        <!-- <div class="close" v-on:click="close(false)"></div> -->
        <h4 class="title" v-if="editId > 0 && !newUser">Edit User</h4>
        <h4 class="title" v-else>Add New User</h4>
        <form v-on:submit.prevent="handleSubmit">
          <div :class="{userPhoto: true, uploading: uploadingAvatar,
            hasPhoto: avatar}" id="pickAvatar"
            :style="{'background-image': `url('${avatar}')`}">
            <div class="photoIcon"></div>
          </div>
          <div class="fieldGroup">
            <label>Name</label>
            <div :class="{fieldCnt: true, fieldCnt1: true, hasError: form.name.error}">
              <input type="text" class="field" placeholder="First name"
                name="name"
                v-model="form.name.model"
                v-on:input="fieldChanged('name')">
              <div class="fieldError" v-if="form.name.error">{{form.name.error}}</div>
            </div>
            <div :class="{fieldCnt: true, hasError: form.last_name.error}">
              <input type="text" class="field" placeholder="Last name"
                name="last_name"
                v-model="form.last_name.model"
                v-on:input="fieldChanged('last_name')">
              <div class="fieldError" v-if="form.last_name.error">{{form.last_name.error}}</div>
            </div>
            <div class="clear"></div>
          </div>

          <div class="fieldGroup">
            <label>Contact</label>
            <div :class="{fieldCnt: true, fieldCnt1: true, hasError: form.phone.error}">
              <div class="fieldPhone">
                <input type="tel" class="field" placeholder="Phone number"
                  v-model="form.phone.model"
                  v-on:input="fieldChanged('phone')">
                <div class="fieldError" v-if="form.phone.error">
                  {{form.phone.error}}
                </div>
              </div>
            </div>
            <div :class="{fieldCnt: true, hasError: form.email.error}">
              <div class="fieldEmail">
                <input type="email" class="field" placeholder="Email address"
                  v-model="form.email.model"
                  v-on:input="fieldChanged('email')">
                <div class="fieldError" v-if="form.email.error">
                  {{form.email.error}}
                </div>
              </div>
            </div>
            <div class="clear"></div>
          </div>

          <div class="fieldGroup">
            <label>Password</label>
            <template v-if="editId > 0 && !changePassword && !newUser">
              <div class="thePassword">
                * * * * * *
                <span v-on:click="changePassword = true">Change password</span>
              </div>
            </template>
            <template v-else>
              <div :class="{fieldCnt: true, fieldCnt1: true,
                fieldCntPass: true, hasError: form.password.error}">
                <input type="password" class="field fieldPassword" :placeholder="passwordLabel"
                  v-model="form.password.model"
                  v-on:input="fieldChanged('password')">
                <div class="fieldError" v-if="form.password.error">
                  {{form.password.error}}
                </div>
              </div>
              <div :class="{fieldCnt: true, hasError: form.password2.error}">
                <input type="password" class="field" placeholder="Re-type password"
                  v-model="form.password2.model"
                  v-on:input="fieldChanged('password2')">
                <div class="fieldError" v-if="form.password2.error">
                  {{form.password2.error}}
                </div>
              </div>
              <div class="clear"></div>
              <div class="cancelChangePwd" v-if="changePassword"
                v-on:click="changePassword = false">
                <span>Don't change password</span>
              </div>
            </template>
          </div>

          <div class="fieldGroup">
            <label>About</label>
            <textarea class="field" v-model="form.about.model"
              placeholder="About..."></textarea>
          </div>

          <div class="modalAction">
            <button class="btn btnSecondary btnLg" type="button"
              v-on:click="close(false)">Cancel</button>
            <button class="btn btnPrimary btnLg" type="submit">
              <span v-if="editId > 0">Save Changes</span>
              <span v-else>Add User</span>
            </button>
          </div>
        </form>
      </div>
      <AvatarCropper v-on:uploading="uploading" v-on:uploaded="uploaded"
        trigger="#pickAvatar" :upload-url="uploadUrl"
        :output-options="{width: 256, height: 256}"
        :upload-headers="uploadHeaders"
        :labels="{submit: 'Save Avatar', cancel: 'Cancel'}"/>
    </div>
  </transition>
</template>

<script>
import AvatarCropper from 'vue-avatar-cropper';

import config from '../config';

export default {
  components: {
    AvatarCropper,
  },
  data() {
    return {
      show: false,
      next: null,
      editId: null,
      changePassword: false,
      uploadingAvatar: false,
      uploadUrl: '',
      avatar: null,
      uploadHeaders: {},
      newUser: true,
      form: {
        name: { model: '', error: null },
        last_name: { model: '', error: null },
        phone: { model: '', error: null },
        email: { model: '', error: null },
        password: { model: '', error: null },
        password2: { model: '', error: null },
        role: { model: null, error: null },
        about: { model: '', error: null },
      },
    };
  },
  computed: {
    passwordLabel() {
      return (this.editId > 0) ? 'New Password' : 'Password';
    },
  },
  methods: {
    open(d, n) {
      this.form.name.model = (d.model) ? d.model.first_name : '';
      this.form.name.error = null;
      this.form.last_name.model = (d.model) ? d.model.last_name : '';
      this.form.phone.model = (d.model) ? d.model.phone : '';
      this.form.phone.error = null;
      this.form.email.model = (d.model) ? d.model.email : '';
      this.form.email.error = null;
      this.form.password.model = '';
      this.form.password.error = null;
      this.form.password2.model = '';
      this.form.password2.error = null;
      this.form.about.model = (d.model) ? d.model.about : '';
      this.form.about.error = null;
      this.editId = (d.model) ? d.model.id : null;
      this.newUser = (!this.editId);
      this.avatar = (d.model && d.model.avatar) ? d.model.avatar : null;
      this.uploadUrl = (this.editId)
        ? this.$config.uri(`user/avatar2/${this.editId}`)
        : this.$config.uri('user/avatar2');
      this.uploadingAvatar = false;
      this.next = n;
      this.show = true;
    },
    close(b) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b);
    },
    handleSubmit() {
      if (this.form.name.model.trim() === '') {
        this.form.name.error = 'Please input name to continue.';
      } else if (this.form.email.model.trim() === '') {
        this.form.email.error = 'Please email address to continue.';
      } else {
        if ((!this.editId && !this.changePassword) || this.newUser) {
          if (this.form.password.model.trim() === '') {
            this.form.password.error = 'Please password to continue.';
            return;
          }
          if (this.form.password.model.trim().length < 8) {
            this.form.password.error = 'Password minimun 8 character.';
            return;
          }
          if (this.form.password.model !== this.form.password2.model) {
            this.form.password2.error = 'Password did not match.';
            return;
          }
        }

        const formData = {
          name: this.form.name.model,
          last_name: this.form.last_name.model,
          phone: this.form.phone.model,
          email: this.form.email.model,
          about: this.form.about.model,
        };
        if (this.editId > 0) {
          formData.id = this.editId;
        }
        if (!this.editId || this.changePassword) {
          formData.password = this.form.password.model;
        }
        this.$http.post(this.$config.uri('user/save'), formData).then((response) => {
          if (response.data.status === 307) {
            this.form[response.data.field].error = response.data.message;
            return;
          }
          if (response.data.status !== 200) {
            // Display error
            return;
          }
          this.close(true);
        });
      }
    },
    fieldChanged(field) {
      if (field === 'password') {
        if (this.form.password.model.trim().length >= 8) {
          this.form.password.error = null;
        }
      } else if (field === 'password2') {
        if (this.form.password.model === this.form.password2.model) {
          this.form.password2.error = null;
        }
      } else {
        this.form[field].error = null;
      }
    },
    uploading() {
      this.avatar = null;
      this.uploadingAvatar = true;
    },
    uploaded(response) {
      this.uploadingAvatar = false;
      this.avatar = response.avatar;
      if (response.status !== 200) {
        // Display error
        return;
      }
      this.editId = response.id;
      this.uploadUrl = this.$config.uri(`user/avatar2/${this.editId}`);
    },
  },
  mounted() {
    this.uploadHeaders = {
      Key: config.apiKey,
      Authorization: this.$session.get('jwt'),
    };
  },
};
</script>

<style lang="scss">
  .avatar-cropper-overlay{
    .avatar-cropper-mark{
      background-color: rgba(0,0,0,.6);
      backdrop-filter: saturate(180%) blur(20px);
    }
    .avatar-cropper-container{
      padding: 40px 80px;
      border-radius: 5px;
    }
    .avatar-cropper-footer{
      margin: 20px -80px -40px;
      border-top: #eee 1px solid;
      padding: 12px 30px;
      display: block !important;
      text-align: right;
      button{
        margin-left: 10px;
        background-color: #0057d8 !important;
        width: auto !important;
        color: #fff;
        padding: 10px 20px !important;
        border-radius: 4px;
        font-weight: bold;
        font-size: 18px;
        outline: 0 !important;
        cursor: pointer;
        transition: all .2s ease;
        &:hover{
          background-color: #0067ff !important;
        }
        &:first-child{
          background-color: #fff !important;
          color: #0747a6 !important;
          &:hover{
            background-color: #fff !important;
            box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
          }
        }
      }
    }
  }
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 991;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    overflow: auto;
    padding: 40px 0;
    .title{
      text-align: center;
    }
    .userPhoto{
      width: 120px; height: 120px;
      margin: 10px auto 20px;
      border-radius: 50%;
      background-color: #eee;
      position: relative;
      cursor: pointer;
      background-size: cover;
      background-position: center;
      &:before{
        content: "";
        position: absolute;
        top: 0; right: 0; bottom: 0; left: 0;
        background-image: url(../assets/user-placeholder.png);
        background-size: 100px auto;
        background-position: 50% 28px;
        background-repeat: no-repeat;
        opacity: .2;
        border-radius: 50%;
      }
      &.uploading{
        &:before{
          background-image: url(../assets/loading.svg);
          background-position: center;
          background-size: 60px auto;
          opacity: .4;
        }
      }
      &.hasPhoto{
        &:before{
          display: none;
        }
      }
      .photoIcon{
        width: 32px; height: 32px;
        background-color: #0057d8;
        border-radius: 50%;
        position: absolute;
        right: -6px; top: -2px;
        cursor: pointer;
        background-image: url(../assets/photo-white.png);
        background-size: 16px auto;
        background-position: center;
        background-repeat: no-repeat;
        &:hover{
          background-color: #0067ff;
          box-shadow: 2px 2px 2px rgba(0,0,0,.2);
        }
      }
    }

    .fieldCnt.hasError{
      .field{
        border-color: red;
      }
      .fieldError{
        display: block;
      }
    }
    .fieldCnt.fieldCntPass.hasError{
      .field{
        margin-bottom: 0;
      }
      .fieldError{
        margin-bottom: 10px;
      }
    }

    .overlay{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: relative;
      z-index: 2;
      background: #fff;
      width: 260px;
      margin: auto;
      border-radius: 5px;
      padding: 40px 100px;
      .close{
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-image: url(../assets/close.png);
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        right: 10px;
        top: 10px;
        opacity: .4;
        cursor: pointer;
        transition: all .2s linear;
      }
      .close:hover{
        background-color: #e5e5e5;
        opacity: .7;
      }
      h4{
        font-size: 30px;
        margin: 0;
        margin-bottom: 20px;
      }

      .modalAction{
        margin: 30px -80px -40px;
        padding: 12px 30px;
        text-align: right;
        // background-color: #eee;
        border-top: #eee 1px solid;
        position: relative;
        .btn{
          margin-left: 10px;
        }
      }
    }
  }

  .fieldGroup{
    .field.fieldPassword{
      margin-bottom: 10px;
    }
    .fieldPhone{
      margin-bottom: 10px;
    }
    .fieldPhone, .fieldEmail{
      position: relative;
    }
    .fieldPhone:before, .fieldEmail:before{
      content: "";
      background-size: contain;
      background-image: url(../assets/phone2.png);
      background-position: center;
      width: 18px; height: 18px;
      position: absolute;
      left: -30px;
      top: 12px;
      z-index: 4;
      opacity: .3;
    }
    .fieldEmail:before{
      background-image: url(../assets/email.png);
    }
  }
  .thePassword{
    padding-left: 7px;
    font-size: 30px;
    margin-top: 10px;
    margin-bottom: -5px;
    font-weight: bold;
    color: #767676;
    span{
      font-size: 14px;
      float: right;
      color: #0057d8;
      padding: 3px 12px;
      border-radius: 40px;
      cursor: pointer;
      margin-top: 3px;
      margin-right: -5px;
    }
    span:hover{
      background-color: #eee;
    }
  }
  .cancelChangePwd{
    text-align: right;
    margin-top: 10px;
    span{
      font-size: 14px;
      color: #0057d8;
      padding: 3px 12px;
      border-radius: 40px;
      cursor: pointer;
      margin-right: -5px;
      font-weight: bold;
    }
    span:hover{
      background-color: #eee;
    }
  }

  .modalContent.modalBig{
    width: 480px;
    padding: 40px 80px;
    .cancelChangePwd{
      margin-top: 0;
    }
    .fieldGroup{
      .fieldCnt{
        float: left;
        width: calc(50% - 10px);
      }
      .fieldCnt.fieldCnt1{
        margin-right: 20px;
      }
      .fieldPhone, .fieldEmail{
        margin-bottom: 0;
        .field{
          padding-left: 38px;
        }
      }
      .fieldPhone:before, .fieldEmail:before{
        left: 12px;
        top: 15px;
      }
    }
  }
</style>
